import { forwardRef, useImperativeHandle, useState } from 'react'
import { t } from 'i18next'
import ButtonPrimaryOutlined from 'src/components/shared/ui/ButtonPrimaryOutlined'
import ButtonSecondary from 'src/components/shared/ui/ButtonSecondary'
import ButtonSecondaryOutlined from 'src/components/shared/ui/ButtonSecondaryOutlined'
import { LexonIcon } from 'src/components/shared/ui/Icons'
import LexnetDialog from 'src/components/shared/ui/LexnetDialog'
import LexnetIconButton from 'src/components/shared/ui/form/fields/LexnetIconButton'
import useNewModal from 'src/hooks/useModal'
import { Contact } from 'src/interfaces/lexon'
import ContactsTable from './ContactsTable'

type Props = {
  disabled: boolean
  contactData: (item: Contact | null) => void
}

export function ContactsSelectorOld(props: Props): JSX.Element {
  const { contactData, disabled } = props
  const { isOpened, close, open } = useNewModal()
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null)

  function selectContact() {
    contactData(selectedContact)
    setSelectedContact(null)
    close()
  }

  function handleClick() {
    close()
    setSelectedContact(null)
  }

  return (
    <>
      <LexnetIconButton
        aria-label={t('tooltips.search_interviniente')}
        title={t('tooltips.search_interviniente')}
        disabled={disabled}
        handleClick={() => {
          open()
        }}
      >
        <LexonIcon />
      </LexnetIconButton>
      <LexnetDialog
        title={t('dialog.title.lexon_contacts')}
        isOpen={isOpened}
        close={close}
        maxWidth="lg"
        buttons={
          <>
            <ButtonSecondaryOutlined onClick={handleClick}>
              {t('actions.cancel')}
            </ButtonSecondaryOutlined>
            <ButtonPrimaryOutlined onClick={selectContact} disabled={!selectedContact}>
              {t('actions.select')}
            </ButtonPrimaryOutlined>
          </>
        }
      >
        <ContactsTable setSelectedContact={setSelectedContact} />
      </LexnetDialog>
    </>
  )
}

type ContactsSelectorProps = {
  contactData: (item: Contact | null) => void
}

export type ContactsSelectorRefType = {
  open: () => void
}

export default forwardRef<ContactsSelectorRefType, ContactsSelectorProps>(function(
  props,
  ref
): JSX.Element {
  const { contactData } = props
  const { isOpened, close, open } = useNewModal()
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null)

  function selectContact() {
    contactData(selectedContact)
    setSelectedContact(null)
    close()
  }

  function handleClick() {
    close()
    setSelectedContact(null)
  }

  useImperativeHandle(
    ref,
    () => {
      return {
        open: () => {
          open()
        }
      }
    },
    [open]
  )

  return (
    <LexnetDialog
      title={t('dialog.title.lexon_contacts')}
      isOpen={isOpened}
      close={close}
      maxWidth="lg"
      buttons={
        <>
          <ButtonPrimaryOutlined onClick={handleClick}>{t('actions.cancel')}</ButtonPrimaryOutlined>
          <ButtonSecondary onClick={selectContact} disabled={!selectedContact}>
            {t('actions.select')}
          </ButtonSecondary>
        </>
      }
    >
      <ContactsTable setSelectedContact={setSelectedContact} />
    </LexnetDialog>
  )
})
